exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userListTable_2QH3J {\n    font-size: 12px;\n}\n\n.userListTable_2QH3J thead tr th {\n    text-align: center;\n}\n\n.userListTable_2QH3J .empty_1W-jq {\n    text-align: center;\n}\n\n.userListTable_2QH3J tbody tr td {\n    cursor: pointer;\n}\n\n.userListTable_2QH3J tbody tr td,\n.userListTable_2QH3J tbody tr th {\n    text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"userListTable": "userListTable_2QH3J",
	"empty": "empty_1W-jq"
};